import { useEffect, useRef } from "react";

import { useLocation, useSearchParams } from "utils";

// Runs on every navigation (location.key), since re-opening a link already in the URL keeps the same searchParams.
export const useOnNavigationSearchParams = (onNavigation: (searchParams: URLSearchParams) => void): void => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const latestRef = useRef({ onNavigation, searchParams });
  latestRef.current = { onNavigation, searchParams };

  useEffect(() => {
    latestRef.current.onNavigation(latestRef.current.searchParams);
  }, [location.key]);
};
